export const WINDOW_DATA_PROPERTY = '__ssr__';
